// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clientData[data-v-dfc27d18] {\n  width: 100%;\n  height: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
